import { __awaiter, __generator } from "tslib";
import { getNativeUrl } from '../utilities/getNativeUrl';
import { launchUrlInWeb } from './launchUrlInWeb';
/**
 * launchInDesktop with generate and open a url that will hint to the browser
 * to attempt to open the given document in it's native app
 * @param document
 * @param launchInstrumentationParams
 * @returns A promise containing the result of the attempted launch
 */
export function launchInDesktop(document, launchInstrumentationParams) {
    return __awaiter(this, void 0, void 0, function () {
        var nativeUrl;
        return __generator(this, function (_a) {
            nativeUrl = getNativeUrl(document);
            return [2 /*return*/, launchUrlInWeb('OpenNativeDocument', nativeUrl !== null && nativeUrl !== void 0 ? nativeUrl : '', launchInstrumentationParams, '_blank')];
        });
    });
}
//# sourceMappingURL=launchInDesktop.js.map